import { tick } from 'svelte';
export function portal(node, target = 'body') {
    let targetEl;
    async function update(newTarget) {
        const target = newTarget;
        if (typeof target === 'string') {
            targetEl = document.querySelector(target);
            if (targetEl === null) {
                await tick();
                targetEl = document.querySelector(target);
            }
        }
        else if (target instanceof HTMLElement) {
            targetEl = target;
        }
        if (!targetEl) {
            throw new Error(`Target element "${target}" not found`);
        }
        targetEl.appendChild(node);
        node.hidden = false;
    }
    update(target);
    function destroy() {
        node.remove();
    }
    return { update, destroy };
}
